export const SANCTIONED_COUNTRIES: { id: string; name: string }[] = [
  { id: 'AF', name: 'Afghanistan' },
  { id: 'BY', name: 'Belarus' },
  { id: 'CU', name: 'Cuba' },
  { id: 'IR', name: 'Iran' },
  { id: 'RU', name: 'Russia' },
  { id: 'SY', name: 'Syria' },
  { id: 'KP', name: 'North Korea' },
  { id: 'VE', name: 'Venezuela' },
];
